<template>
  <div class="newsDscription modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>

    <template v-if="modalData">
      <div class="imgNews"><img :src="imageLink(onenews.main_image)" /></div>
      <div class="newsData">
        <h1 class="titleNews">{{ onenews.new_title }}</h1>
        <p class="newsdate">{{ onenews.new_date }}</p>
        <p class="autor">Author: {{ onenews.new_author }}</p>
        <div class="description" v-html="onenews.new_article"></div>
      </div>
    </template>
  </div>
</template>

<script>
// old modal news
import eventBus from "@/shared/eventBus.js";
import { api, baseURL } from "@/api";
export default {
  name: "NewsDescription",
  props: ["modalData"],
  data() {
    return {
      onenews: Object
    };
  },
  methods: {
    closeModal() {
      eventBus.$emit("closeModal");
    },
    imageLink(image) {
      return baseURL + image;
    },
    getNewsInfo(id) {
      api
        .getNewsInfo(id)
        .then(res => {
          this.onenews = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
    this.getNewsInfo(this.modalData);
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";
@import "@/assets/scss/scrollbarStyles.scss";

.newsDscription {
  font-family: Ubuntu;
  text-align: left;
  width: 70%;
  height: 80vh;
  padding: 25px;
  padding-bottom: 59px;
  padding-top: 25px;
  background: #ffffff;
  box-shadow: 0px 7px 36px rgba(0, 0, 0, 0.06);
  overflow: auto;

  .titleNews {
    font-family: Ubuntu;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    /* identical to box height */

    letter-spacing: 0.06em;

    color: #4b4b4b;
  }
  .imgNews {
    margin: 3% 0;
    width: 100%;
    /* height: 70%; */
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 400px;

    img {
      /* object-fit: cover;
            position: absolute;
            display:block; */
      width: 100%;
    }
  }
  .newsdate {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height */

    letter-spacing: 0.06em;

    color: #9d9d9d;
  }
  .description {
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 149.5%;
    /* or 22px */

    text-align: justify;
    letter-spacing: 0.02em;

    color: #858585;
  }
  .autor {
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    /* identical to box height */

    letter-spacing: 0.06em;
    color: #6a6a6a;
  }
}
@media only screen and (max-width: 850px) {
  .imgNews {
    margin: 3% 0;
    width: 100%;
    max-height: 50%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
            display:block; */
      width: 100%;
    }
  }
}
@media only screen and (max-width: 750px) {
  .imgNews {
    margin: 1% 0;
    width: 100%;
    max-height: 50%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
            display:block; */
      width: 100%;
    }
  }
}
@media only screen and (max-width: 650px) {
  .imgNews {
    margin: 1% 0;
    width: 100%;
    max-height: 40%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      /* position: absolute;
            display:block; */
      width: 100%;
    }
  }
}
</style>
